import script from "./AdministratorPortfolioLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorPortfolioLayout.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorPortfolioLayout.vue?vue&type=style&index=0&id=ad9c589e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad9c589e"]])

export default __exports__